<div class="" *transloco="let t; read: 'ime.components.help'">
  <p *ngIf="!isLoading && !value">
    {{t('Nothing found on this topic')}}
    <button class="btn btn-primary mx-2" (click)="create()">{{t('Create now')}}</button>
  </p>
  <p *ngIf="isLoading">
    {{t('Loading')}}...
  </p>
  <div *ngIf="!isLoading && value" [innerHTML]="value | safe: 'html'"></div>
</div>
